import React, { useContext, useEffect } from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import { FormContext } from '../../common/form/FormContext';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';
import I18n from '../../common/i18n/I18n';
import { arrayToSelectOptionsLocalized, SelectTypeEnum } from '../attributes';
import { AVAILABLE_REFERENCE_ENTITIES } from './referenceConstants';

export default function ReferenceFieldEditor() {
    const { setState } = useContext(FormContext);

    useEffect(() => {
        setState((prevVal) => {
            const desiredSelectTypeId =
                prevVal.selectType?.id ?? (prevVal.isMultiSelect ? SelectTypeEnum.multi : SelectTypeEnum.single);
            if (prevVal.selectType && prevVal.selectType.id === desiredSelectTypeId) {
                return prevVal;
            }

            const selectTypeValue = {
                id: desiredSelectTypeId,
                label: desiredSelectTypeId
            };

            return {
                ...prevVal,
                selectType: selectTypeValue
            };
        });
    }, [setState]);

    useEffect(() => {
        setState((prevVal) => {
            if (prevVal.allowCreate === undefined) {
                return { ...prevVal, allowCreate: true };
            }
            return prevVal;
        });
    }, [setState]);

    const entityOptions = AVAILABLE_REFERENCE_ENTITIES.map((entity) => ({
        id: entity.value,
        label: entity.label
    }));

    return (
        <FormPanel>
            <FormContainer>
                <FormItem>
                    <FormWidget name="label" label={<I18n token="common.label" />} />
                </FormItem>
                <FormItem>
                    <FormWidget name="group" label={<I18n token="common.group" />} />
                </FormItem>
                <FormItem>
                    <FormWidget
                        name="description"
                        component={FORM_WIDGET_COMPONENTS.textArea}
                        label={<I18n token="common.description" />}
                    />
                </FormItem>
                <FormItem quarter>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="required"
                        label={<I18n token="common.required" />}
                    />
                </FormItem>
                <FormItem quarter>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="keyInformation"
                        label={<I18n token="termset.label.key.information" />}
                    />
                </FormItem>
                <FormItem quarter>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="allowCreate"
                        label={<I18n token="attributes.reference.allowNewAddition" />}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.chips}
                        name="selectType"
                        coerceChangeToArray
                        options={arrayToSelectOptionsLocalized(Object.values(SelectTypeEnum))}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        name="entityToReference"
                        label={<I18n token="attributes.reference.label.entity" />}
                        options={entityOptions}
                        allowFreeForm={false}
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
}
